import React from 'react'
import './styles.scss'

export const FilterToggle = ({ toggleFilters, isFiltersExpanded, toggleLabel = 'Filter' }) => {
  return (
    <>
      <div className="FilterToggle__label">{toggleLabel}</div>
      <label className="FilterToggle__switch">
        <input
          type="checkbox"
          onChange={toggleFilters}
          checked={isFiltersExpanded}
        />
        <span className="FilterToggle__switch-slider"></span>
      </label>
    </>
  )
}
